/**
 * Navigates back to the previous page when there is same-site history to return to,
 * otherwise falls back to the link's own `href` (e.g. the product's collection, or home).
 */
class ProductBackButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    if (window.history.length <= 1) return;

    event.preventDefault();
    window.history.back();
  };
}

if (!customElements.get('product-back-button')) {
  customElements.define('product-back-button', ProductBackButton);
}
